<template>
  <div class="topPart" :style="backgroundDiv">
    <!-- AI语音解决方案 -->
    <div
      style="align-items: center;width:100%;height:100%;display:flex;flex-direction:column;
    justify-content: center;"
    >
      <div class="sizeSet">
<!--        <div class="topPartTitle">背景概述</div>-->
<!--        <div class="topPartTitle_1 topPartMargin">空中交通管制工作的目标是保障飞行安全，同时最大程度利用有限的空域资源。</div>-->
<!--        <div class="paddingImg">-->
<!--          <div>• 民航蓬勃发展，飞机班次大大增多，安全事故征候高发</div>-->
<!--          <div>• 空管严重依赖管制员长时间高强度专注集中工作，易产生人为偏差</div>-->
<!--          <div>• 管制语音以原始音频记录为主，缺少有效的转录和数字化手段</div>-->
<!--          <div>• AI技术的迅速发展，语音识别趋于成熟，可以实现语音语义识别场景</div>-->
<!--        </div>-->
<!--        <div class="topPartTitle_1 topPartMargin_1">如何同时提高安全和效率？</div>-->
<!--        <div class="paddingImg1">-->
<!--          <div class="ai_page">-->
<!--            <div>事中识别：</div>-->
<!--            <div>实时智能分析指令，提高管制安全</div>-->
<!--          </div>-->
<!--          <div class="ai_page">-->
<!--            <div>事后分析：</div>-->
<!--            <div>精细评价管制过程，提高管制效率</div>-->
<!--          </div>-->
<!--        </div>-->
        <div class="sizeSet-content">
          <div @click="swiperClick(1 )" style="cursor: pointer">
            <div class="security bg">
              <div class="security-son"></div>
            </div>
            <p>安全防护</p>
          </div>

          <div @click="swiperClick(2)" style="margin-left: 170px;;cursor: pointer">
            <div class="train bg">
              <div class="train-son"></div>
            </div>
            <p>管制培训</p>
          </div>
          <div @click="swiperClick(3)" style="margin-left: 170px;cursor: pointer">
            <div  class="flight bg">
              <div class="flight-son"></div>
            </div>
            <p>合规检查/管理</p>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
.sizeSet-content{
  display: flex;
  justify-content: flex-start;
  align-items: center;
  .bg{
    background: url("../assets/polygon-6.png");
    background-position: left 50% top 9.6%;
  }
  p{
    font-size: 24px;
    text-align: center;
    margin-top: 12px;
  }
  .security{

    width: 194px;
    height: 226px;
    display: flex;
    justify-content: center;
    align-items: center;
    .security-son{
      width: 124px;
      height: 102px;
      background: url("../assets/security.png");
      background-position: left 70.6% top 10.8%;
    }
  }
  .flight{

    width: 194px;
    height: 226px;
    display: flex;
    justify-content: center;
    align-items: center;
    .flight-son{
      width: 124px;
      height: 102px;
      background: url("../assets/flight.png");
      background-position: left 50% top 10.8%;
    }
  }
  .train{
    width: 194px;
    height: 226px;
    display: flex;
    justify-content: center;
    align-items: center;
    .train-son{
      width: 124px;
      height: 102px;
      background: url("../assets/train.png");
      background-position: left 29.6% top 10.8%;
    }
  }
}
.topPartTitle {
  font-size: 40px;
  margin-bottom: 70px;
}
.topPartMargin_1 {
  margin-bottom: 30px;
}
.topPartMargin {
  margin-bottom: 50px;
}
.paddingImg > div {
  margin-bottom: 25px;
  color: #d3d3d3;
}
.paddingImg1 {
  padding-left: 130px;
  background: url("../../../common/commonImages/ai_1.png") no-repeat;
  background-size: 88px 88px;
  height: 100px;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  background-position-x: 20px;
  background-position-y: center;
  font-size: 24px;
}
.ai_page {
  display: flex;
}
.ai_page > div:nth-child(1) {
  color: #fff;
}
.ai_page > div:nth-child(2) {
  color: #d3d3d3;
}
.paddingImg {
  font-size: 24px;
  padding-left: 130px;
  background: url("../../../common/commonImages/ai_2.png") no-repeat;
  background-size: 89px 68px;
  background-position-x: 20px;
  background-position-y: center;
}
.sizeSet {
  display: flex;
  justify-content: center;
  align-items: center;
  /*width: 970px;*/
  /*height: 720px;*/
  /* padding-top: 80px; */
}
.topPartTitle {
  text-align: center;
}
.topPartTitle_1 {
  text-align: left;
}
.topPartTitle_1 {
  color: #62a3fc;
  font-size: 26px;
}
</style>

<script>
export default {
  name: "HomeSlide1",
  data() {
    return {
      contentVal: "人力有时而穷 可引AI而用之<br/>矢志坚一节 始终持一心",
      backgroundDiv: {
        backgroundImage: "url(" + require("../assets/aiSlide.jpg") + ")",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center",
        backgroundSize: "cover",
        width: "100%",
        height: "100%"
      }
    };
  },
  created: function() {},
  mounted: function() {
    if (window.location.href.indexOf("production") > 0) {
      //产品页面
      this.contentVal = "基于大数据技术和人工智能的数据服务平台";
      this.backgroundDiv.backgroundImage =
        "url(" + require("../assets/productionSlide1.jpg") + ")";
    }
  },
  methods: {
    swiperClick( index ){
      this.$emit('swiperClick',index)
    }
  }
};
</script>
